module.exports = __webpack_public_path__ + "img/57445ad.png";